import client from '../../../apis/portaliref';
import helper from 'helpers/steinerHelper';

const apis = helper.createApi('paginaOfferta', client, {
    per_page: 'perPage',
    page: 'page',
    slug: 'q',
    sort_field: 'orderKey',
    sort_direction: 'orderDirection',
    portale: 'portale',
    comune: 'comune',
    tipologia_offerta: 'tipologia_offerta',
});

// API backend: https://github.com/Adrias-Online/ao-portali/blob/main/config/routes/pagina-destinazione.yaml 
// (quelle con paginaOfferta nel path)
apis.create = (data) => {
    return client({
        url: 'paginaOfferta',
        method: 'POST',
        data,
    });
};

apis.editPage = (id, data) => {
    return client({
        url: `paginaOfferta/${id}`,
        method: 'PATCH',
        data,
    });
};

apis.deletePage = (id, data) => {
    return client({
        url: `paginaOfferta/${id}`,
        method: 'DELETE',
        data,
    });
};

apis.elencoDestinazioni = () => {
    return client({
        url: 'destinazioni/listaNomi',
        method: 'GET',
    });
};

apis.getTipologieOfferta = () => {
    return client({
        url: 'offerta/tipologie/perPagina',
        method: 'GET',
    });
};
export default apis;